import { jsx as _jsx } from "react/jsx-runtime";
import { useMatch } from 'react-router-dom';
export function TopMenuItem({ to, className, children }) {
    const match = useMatch(to + '/*');
    const classlist = [];
    if (className != undefined) {
        classlist.push(className);
    }
    if (match != null) {
        classlist.push('active');
    }
    const classes = classlist.length > 0 ? classlist.join(' ') : undefined;
    return (_jsx("div", { role: "menuitem", className: classes, children: children }));
}
